type TypographyPrimitiveRecord = Record<
  string,
  {
    fontFamily: string;
    fontWeight: number;
    fontSize: number;
    lineHeight: number;
    letterSpacing: number;
  }
>;

export function typographySemanticFromMap<
  P extends TypographyPrimitiveRecord,
  const M extends Record<string, keyof P & string>,
>(primitives: P, map: M): { [K in keyof M]: P[M[K]] } {
  const result = {} as { [K in keyof M]: P[M[K]] };
  for (const semanticKey of Object.keys(map) as (keyof M)[]) {
    const primitiveKey = map[semanticKey];
    result[semanticKey] = primitives[primitiveKey];
  }
  return result;
}
